import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CustomerAdminFeatureComponent } from './customer-admin-feature/customer-admin-feature.component';

const log = new LoggingService();

export const CustomerAdminRoute: Ng2StateDeclaration = {
    name: 'companyinfo',
    url: '/companyinfo',
    data: { requiresAuth: true },

    component: CustomerAdminFeatureComponent
};
